import React from 'react';
import * as Flags from 'country-flag-icons/react/3x2';

interface CountryFlagProps {
  countryCode: string;
  className?: string;
  title?: string;
  width?: number;
  height?: number;
}

export function CountryFlag({ 
  countryCode, 
  className = "", 
  title,
  width = 24,
  height = 16 
}: CountryFlagProps) {
  const FlagComponent = (Flags as any)[countryCode.toUpperCase()];
  
  if (!FlagComponent) {
    // Fallback for unknown country codes
    return (
      <div 
        className={`bg-gray-200 rounded flex items-center justify-center text-xs text-gray-500 ${className}`}
        style={{ width, height }}
        title={title || `Unknown country: ${countryCode}`}
      >
        {countryCode.toUpperCase()}
      </div>
    );
  }

  return (
    <FlagComponent
      className={className}
      title={title || `${countryCode.toUpperCase()} flag`}
      width={width}
      height={height}
    />
  );
}

export default CountryFlag; 